import { useQuery } from "react-query";
import {
  useBundleRefsIntoDocument,
  useParsedValue,
} from "@stoplight/elements-core";
import { useMemo } from "react";
import { useExportDocumentProps } from "@stoplight/elements";
import { getArticles } from "tools/utils";
import { articles as _articles } from "fixtures/articles";
import { transformOasToServiceNode } from "tools/oas";
import { ServiceChildNode } from "tools/oas/types";
import { getDocs } from "fixtures/endpoints";

export function useDocument() {
  const {
    data: fetchedDocument,
    isLoading,
    error,
  } = useQuery(["docs"], () => getDocs(), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const parsedDocument = useParsedValue(fetchedDocument);
  const bundledDocument = useBundleRefsIntoDocument(parsedDocument);
  const exportProps = useExportDocumentProps({
    originalDocument: fetchedDocument as object,
    bundledDocument,
  });

  const nodes = useMemo(() => {
    const articles = getArticles(_articles);
    const servicesNode = transformOasToServiceNode(bundledDocument);
    servicesNode?.children.push(
      ...(articles as unknown as Array<ServiceChildNode>)
    );
    return servicesNode;
  }, [bundledDocument]);

  return {
    isLoading,
    nodes,
    exportProps,
    error,
    bundledDocument,
    parsedDocument,
  };
}
